import { useQuery } from "@tanstack/react-query"
import { getPricingTableData, getPlanComparisonData } from "sdk/billing"

export const billingKeys = {
  all: ["billing"],
  pricingTable: promoCode => [...billingKeys.all, "pricingTable", promoCode],
  planComparisonData: promoCode => [
    ...billingKeys.all,
    "planComparisonData",
    promoCode
  ]
}

export function usePricingTable({ promoCode, ...queryOptions } = {}) {
  return useQuery({
    queryKey: billingKeys.pricingTable(promoCode),
    queryFn: () => getPricingTableData({ promoCode }),
    ...queryOptions
  })
}

export function usePlanComparisonData({ promoCode, ...queryOptions } = {}) {
  return useQuery({
    queryKey: billingKeys.planComparisonData(promoCode),
    queryFn: () => getPlanComparisonData({ promoCode }),
    ...queryOptions
  })
}
